import 'css-chunksrc/client/pages/planzoneMembersPage/resourcesMenu/groups/elementLoader/styles.scss';export default {
  "memberLoader": "_memberLoader_17qsl_1",
  "title": "_title_17qsl_6",
  "member": "_member_17qsl_1"
};